import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { TutorService } from '../tutor.service';
import { CommonModule } from '@angular/common';
import { GlobalFunctions } from '../../../../core/global-functions';
import { CommonService } from '../../../../core/common.service';
import { CONSTANTS } from '../../../../core/constants';

@Component({
  selector: 'app-t-and-c',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, CheckboxModule, ToastModule],
  templateUrl: './t-and-c.component.html',
  styleUrl: './t-and-c.component.scss'
})
export class TAndCComponent implements OnInit {
  profileDetails: any;
  tc: boolean = false;
  isBtnLoading: boolean = false;
  public constants = CONSTANTS;
  constructor(
    private _tutorServices: TutorService,
    private _globalFunctions: GlobalFunctions,
    private messageService: MessageService,
    private _router: Router,
    private _commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.getUserDetails();
    this.profileDetails = this._commonService.getProfileDataFromLocalStorage();
  }

  goBack() {
    this._router.navigate(['/tutor-signup/' + this.constants.tutorRatPerHourUrl]);
  }

  getUserDetails() {
    this._commonService.getProfile().subscribe({
      next: (result: any) => {
        if (result && result.success && result.data) {
          this.profileDetails = result.data;
          this._commonService.setProfileData(result.data); // Update local storage
          this.tc = result.data?.tc;
        }
      },
      error: (error: any) => {
        const errorMsg = error?.error?.message || error?.message || 'Failed to load profile details.';
        this.messageService.add({ severity: 'error', summary: 'Oops..!', detail: errorMsg });
      }
    });
  }

  updateProfile() {
    if (!this.tc) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please accept terms and conditions' });
      return;
    }
    this.isBtnLoading = true;
    this._tutorServices.updateProfile({ tc: this.tc }).subscribe({
      next: (result: any) => {
        if (result && result.success) {
          this.isBtnLoading = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: result.message });
          this._commonService.getProfile(false, true).subscribe({
            next: (profileResult: any) => {
              if (profileResult && profileResult?.success) {
                this._commonService.setProfileData(profileResult?.data);
                if (profileResult?.data?.profile_status === 'approved') {
                  this._router.navigate(['/tutor/dashboard']);
                } else {
                  this._router.navigate(['/thank-you']);
                }
              } else {
                this.isBtnLoading = false;
                const errorMsg = profileResult?.message || 'Failed to fetch updated profile.';
                this.messageService.add({ severity: 'error', summary: 'Oops..!', detail: errorMsg });
              }
            },
            error: (error: any) => {
              this.isBtnLoading = false;
              const errorMsg = error?.error?.message || error?.message || 'Failed to fetch updated profile.';
              this.messageService.add({ severity: 'error', summary: 'Oops..!', detail: errorMsg });
            }
          });
        } else {
          this.isBtnLoading = false;
          const errorMsg = result?.message || 'Submission failed.';
          this.messageService.add({ severity: 'error', summary: 'Oops..!', detail: errorMsg });
        }
      },
      error: (error: any) => {
        this.isBtnLoading = false;
        const errorMsg = error?.error?.message || error?.message || 'Something went wrong during submission.';
        this.messageService.add({ severity: 'error', summary: 'Oops..!', detail: errorMsg });
      }
    });
  }
}